<label  class="cx_checkbox__container">{{label}}
  <input
    type="checkbox"
  >
  <span  (click)="sendMessage()" class="checkmark"></span>
</label>
